import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { requestEmailVerificationCode, User } from '@elevator/ui';
import { reportError } from '../lib/errors';

/**
 * Custom hook for sending initial verification code on mount.
 * Sends verification code automatically when component mounts if user is not verified.
 *
 * @param currentUser - The current user object (can be null/undefined)
 */
export const useInitialVerificationCode = (currentUser: User | null | undefined) => {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    // Send verification code when component mounts
    if (currentUser && !currentUser.emailVerified) {
      requestEmailVerificationCode(process.env.AUTH_ENDPOINT)
        .then(() =>
          enqueueSnackbar('Verification code sent!', {
            variant: 'info',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          }),
        )
        .catch((err: unknown) => {
          reportError(err, {
            metaData: {
              operation: 'cognito requestEmailVerificationCode',
            },
            user: {
              username: currentUser.username,
            },
          });
          enqueueSnackbar(
            `Could not send verification code, please make sure you're logged in`,
            {
              variant: 'error',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
              },
            },
          );
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
